import "@hotwired/turbo-rails"
import "./controllers"

import { createRoot } from "react-dom/client"
import { BrowserRouter } from "react-router-dom"
import App from "./components/App"

// O SPA só monta na área autenticada (#app-root). A landing e o admin são
// server-rendered e compartilham este bundle apenas pelo Turbo/Stimulus.
function montar() {
  const raiz = document.getElementById("app-root")
  if (!raiz || raiz.dataset.montado === "1") return

  raiz.dataset.montado = "1"
  createRoot(raiz).render(
    <BrowserRouter>
      <App />
    </BrowserRouter>
  )
}

document.addEventListener("DOMContentLoaded", montar)
document.addEventListener("turbo:load", montar)
